<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-container">

        <vs-button radius icon="icon-plus" icon-pack="feather" @click="addOpenPopup()" class="ml-auto" style="margin-top: -43px;margin-bottom: 15px;"></vs-button>

        <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" :data="items"> <!-- tag search -->

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div
                        class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ items.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : items.length }} of {{ items.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                    </div>
                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=5"><span>5</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=10"><span>10</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=25"><span>25</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50"><span>50</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100"><span>100</span></vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th>{{ $t('id') }}</vs-th>
                <vs-th>{{ $t('title') }}</vs-th>
                <vs-th>{{ $t('description') }}</vs-th>
                <vs-th>{{ $t('users') }}</vs-th>
                <vs-th >{{ $t('createdAt') }}</vs-th>
                <vs-th>{{ $t('action') }}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody ref="table_modal">
                    <tr :data="item" :key="index" v-for="(item,index) in data">
                        <vs-td><p class="id">{{ item.id }}</p></vs-td>
                        <vs-td><p class="name">{{ item.title }}</p></vs-td>
                        <vs-td><p class="name">{{ item.description }}</p></vs-td>
                        <vs-td><p class="name">{{ item.users_count }}</p></vs-td>
                        <vs-td><p class="product-price">{{ item.created_at }}</p></vs-td>
                        <vs-td>
                            <a @click="getById(item.id)" style="cursor:pointer;">{{ $t('edit') }}</a>
                            <span>&nbsp;|&nbsp;</span>
                            <a @click="remove(item.id)" style="cursor:pointer;">{{ $t('delete') }}</a>
                        </vs-td>
                    </tr>
                </tbody>
            </template>
        </vs-table>

        <vs-popup class="holamundo max-w-1000" v-bind:title="'Group '+modalButtonText" :active.sync="addAndEditPopup">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('title') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="title" v-model="editOrAdd.title" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('description') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-textarea name="description" v-model="editOrAdd.description" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('users') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-select multiple v-model="editOrAdd.users" name="users" class="w-full select-large">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in users" class="w-full" />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button color="success" type="filled" @click="editOrAddUser()">{{ modalButtonText }}</vs-button>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>

    export default {
        components: {
        },
        data() {
            return {
                users: [],
                locale: this.$i18n.locale,
                userInfo: window.userInfo,
                modalButtonText: this.$t('save'),
                items: [],
                addAndEditPopup: false,
                editAndAddTemplate: {
                    id: 0,
                    title: '',
                    description: '',
                    users: [],
                    _method: 'POST'
                },
                editOrAdd: {},

                show: false,
                selected: [],
                itemsPerPage: 10,
                isMounted: false,
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            }
        },
        methods: {
            getById(id){
                this.modalButtonText = this.$t('save');
                this.$vs.loading();
                this.editOrAdd = JSON.parse(JSON.stringify(this.editAndAddTemplate));
                this.editOrAdd.id = id;
                const thisIns = this;

                this.reloadUsers(id, function(){
                    axios.get(apiUrl+'/groups/'+id+'/edit?token='+token)
                        .then(function (response) {

                            let data = response.data;
                            if(data.code === 200){
                                for(var index in data.data) {
                                    if (data.data.hasOwnProperty(index)) {
                                        thisIns.editOrAdd[index] = data.data[index];
                                    }
                                }
                                thisIns.addAndEditPopup = true;
                            }else{
                                if (data.code === 401){
                                    window.logout();
                                }
                                thisIns.$vs.notify({
                                    title: 'Error',
                                    text:  data.message,
                                    color: 'danger',
                                    iconPack: 'feather',
                                    icon: 'icon-alert-circle'
                                });
                            }
                            thisIns.$vs.loading.close();
                        });
                });
            },
            editOrAddUser(){
                this.$vs.loading();
                // eslint-disable-next-line no-undef
                let url = apiUrl+'/groups?token='+token;
                this.editOrAdd._method = 'POST';
                if(this.editOrAdd.id !== 0){
                    // eslint-disable-next-line no-undef
                    url = apiUrl+'/groups/'+this.editOrAdd.id+'?token='+token;
                    this.editOrAdd._method = 'PUT';
                }

                const thisIns = this;
                let sendData = new FormData();

                for(let index in thisIns.editOrAdd) {
                    let value = thisIns.editOrAdd[index];
                    sendData.append(index, value);
                }

                axios.post(url, sendData)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.items = data.data;
                            thisIns.addAndEditPopup = false;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            addOpenPopup(){
                this.$vs.loading();
                const thisIns = this;
                this.editOrAdd = JSON.parse(JSON.stringify(this.editAndAddTemplate));
                this.modalButtonText = this.$t('add');
                this.reloadUsers(0, function(){
                    thisIns.$vs.loading.close();
                    thisIns.addAndEditPopup = true;
                });
            },
            remove(id){
                const thisIns = this;
                // eslint-disable-next-line no-undef
                axios.post(apiUrl+'/groups/'+id+'?token='+token, {'_method' : 'DELETE'})
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.items = data.data;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }

                    });
            },
            reloadUsers(groupId = 0, callback){
                const thisIns = this;
                axios.get(apiUrl+'/users/nonGroup/'+groupId+'?token='+token)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.users = data.data;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        callback();
                    });
            }
        },
        created() {
            const thisIns = this;
            // eslint-disable-next-line no-undef
            axios.get(apiUrl+'/groups?token='+token)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.items = data.data;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });

        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>

<style lang="scss">

    .active {

        path {
            fill: #d92121 !important;
        }
    }



    .ui-selected {
        background: rgba(var(--vs-primary), .05) !important;
        color: rgba(var(--vs-primary), 1);
        -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
        box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
    }

    .td-check {
        display: none !important;
    }

    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
